import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import {
  CaseManagementEvent,
  CreateCaseManagementEventRequest,
  UpdateCaseManagementEventRequest,
  CaseManagementEventsFilter,
  CaseManagementAggregates,
} from "@visitproof/types";

interface GetEventsResponse {
  events: CaseManagementEvent[];
  totalCount: number;
  hasMore: boolean;
}

interface GetReportResponse {
  events: CaseManagementEvent[];
  aggregates: CaseManagementAggregates;
  totalCount: number;
  hasMore: boolean;
}

export const CaseManagementService = {
  async createEvent(
    data: CreateCaseManagementEventRequest,
  ): Promise<CaseManagementEvent> {
    const createCaseManagementEvent = httpsCallable(
      functions,
      "createCaseManagementEvent",
    );
    const result = await createCaseManagementEvent(data);
    return result.data as CaseManagementEvent;
  },

  async getEvents(
    caseId: string,
    filter?: Omit<CaseManagementEventsFilter, "caseId">,
    pagination?: { limit?: number; offset?: number },
  ): Promise<GetEventsResponse> {
    const getCaseManagementEvents = httpsCallable(
      functions,
      "getCaseManagementEvents",
    );
    const result = await getCaseManagementEvents({
      caseId,
      ...filter,
      ...pagination,
    });
    return result.data as GetEventsResponse;
  },

  async updateEvent(
    eventId: string,
    data: Omit<UpdateCaseManagementEventRequest, "eventId">,
  ): Promise<CaseManagementEvent> {
    const updateCaseManagementEvent = httpsCallable(
      functions,
      "updateCaseManagementEvent",
    );
    const result = await updateCaseManagementEvent({ eventId, ...data });
    return result.data as CaseManagementEvent;
  },

  async deleteEvent(eventId: string): Promise<void> {
    const deleteCaseManagementEvent = httpsCallable(
      functions,
      "deleteCaseManagementEvent",
    );
    await deleteCaseManagementEvent({ eventId });
  },

  async getReport(
    filter: CaseManagementEventsFilter,
    pagination?: { limit?: number; offset?: number },
  ): Promise<GetReportResponse> {
    const getCaseManagementReport = httpsCallable(
      functions,
      "getCaseManagementReport",
    );
    const result = await getCaseManagementReport({
      ...filter,
      ...pagination,
    });
    return result.data as GetReportResponse;
  },
};
